import { createContext } from 'react';

import { TodoRowUpdate } from './TodoRowController.types';

export const TableUpdateRowHandlerContext = createContext<TodoRowUpdate | undefined>({
  isUpdateItemLoading: false,
  onUpdateItem: undefined,
});
